module.exports = __webpack_public_path__ + "static/media/liveIcon.49116713.svg";